import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Grid } from '@mui/material';
import PageTitle from 'components/shared/page-title/page-title.component';
import MultiDatePicker from 'components/shared/multi-date-picker/multi-date-picker';
import { LabSettings, Organization } from 'models/organization';

type LabAvailabilityProps = {
    currentLab: Organization;
    inactiveIndices: number[];
    onDayTimesChange: (dayTimes: LabSettings) => void;
    onHolidayDaysChange: (dates: Date[] | number[]) => void;
    onUnavailableDaysChange: (dates: number[]) => void;
};

const LabAvailability: FC<LabAvailabilityProps> = ({
    currentLab,
    inactiveIndices,
    onHolidayDaysChange,
    onUnavailableDaysChange,
}: LabAvailabilityProps) => {
    const { t: translate } = useTranslation(['lab-settings']);
    const [selectedHolidayDays, setSelectedHolidayDays] = useState<Date[] | number[]>(currentLab.holidayDays);
    const [selectedUnAvailableDates, setSelectedUnAvailableDates] = useState<Date[] | number[]>(
        currentLab.unavailableLabDates,
    );

    const handleselectedHolidayDays = (dates: Date[] | number[]) => {
        setSelectedHolidayDays(dates);
        onHolidayDaysChange(dates);
    };

    const handleselectedUnAvailableDates = (dates: number[]) => {
        setSelectedUnAvailableDates(dates);
        onUnavailableDaysChange(dates);
    };

    return (
        <Grid container spacing={2}>
            <Grid item sm={12} md={6}>
                <PageTitle headingStyle="h3" title={translate('lab-settings:CLOSED_DAYS')} />
                <Alert sx={{ marginBottom: '15px' }} severity="info">
                    {translate('lab-settings:CLOSED_DAYS_INFO')}
                </Alert>

                <MultiDatePicker
                    selectedDates={selectedHolidayDays}
                    disableDaysIndex={inactiveIndices}
                    onHandleDates={handleselectedHolidayDays}
                />
            </Grid>
            <Grid item sm={12} md={6}>
                <PageTitle headingStyle="h3" title={translate('lab-settings:NOT_AVAILABLE')} />
                <Alert sx={{ height: '87px', marginBottom: '15px' }} severity="info">
                    {translate('lab-settings:NOT_AVAILABLE_INFO')}
                </Alert>

                <MultiDatePicker
                    selectedDates={selectedUnAvailableDates}
                    disableDaysIndex={inactiveIndices}
                    onHandleDates={handleselectedUnAvailableDates}
                />
            </Grid>
        </Grid>
    );
};

export default LabAvailability;
